import React from "react";
import { Alert, AlertTitle } from "@mui/material";
import { useIntl } from "react-intl";

/**
 * KPI制約説明Infoアラートコンポーネント。
 *
 * variant:
 *   "list"         - KPI一覧ページ上部（使用中KPIがある場合）
 *   "type-locked"  - 型詳細ページ上部（型が削除不可の場合）
 *   "create"       - KPI追加時の注意
 *   "edit-unused"  - 未使用KPIの編集時
 *   "edit-locked"  - 使用中KPIの編集時（操作不可）
 *   "sf-locked"    - 成功要因が削除不可の場合
 *   "goal-locked"  - 目標が編集・削除不可の場合（実績あり）
 */
export default function KpiConstraintAlert({ variant, sx = {} }) {
  const intl = useIntl();
  const t = (id) => intl.formatMessage({ id });

  if (variant === "list") {
    return (
      <Alert severity="info" sx={{ mb: 2, ...sx }}>
        {t("kpi.constraint.list.info")}
      </Alert>
    );
  }

  if (variant === "type-locked") {
    return (
      <Alert severity="warning" sx={{ mb: 2, ...sx }}>
        {t("kpi.constraint.type.locked")}
      </Alert>
    );
  }

  if (variant === "create") {
    return (
      <Alert severity="info" sx={{ mb: 2, ...sx }}>
        <AlertTitle>{t("kpi.constraint.create.title")}</AlertTitle>
        {t("kpi.constraint.create.info")}
      </Alert>
    );
  }

  if (variant === "edit-unused") {
    return (
      <Alert severity="info" sx={{ mb: 2, ...sx }}>
        {t("kpi.constraint.edit.unused")}
      </Alert>
    );
  }

  if (variant === "edit-locked") {
    return (
      <Alert severity="error" sx={{ mb: 2, ...sx }}>
        <AlertTitle>{t("kpi.constraint.edit.locked.title")}</AlertTitle>
        {t("kpi.constraint.edit.locked")}
      </Alert>
    );
  }

  if (variant === "sf-locked") {
    return (
      <Alert severity="warning" sx={{ mb: 2, ...sx }}>
        {t("kpi.constraint.successFactor.locked")}
      </Alert>
    );
  }

  if (variant === "goal-locked") {
    return (
      <Alert severity="warning" sx={{ mb: 2, ...sx }}>
        {t("kpi.constraint.goal.locked")}
      </Alert>
    );
  }

  return null;
}
